// extracted by mini-css-extract-plugin
export default {"createProposal":"create-proposal_createProposal__Az73N","dentistInfo":"create-proposal_dentistInfo__VY32q","addQuotePanel":"create-proposal_addQuotePanel__RFl-0"};